/// <amd-module name="Wit/WorkItemForm/History/SingleLineComment" />
import * as React from "react";
import { useMemo } from "react";
import { IHistoryItem } from "../Common/Services";
interface ISingleLineCommentProps {
    update: IHistoryItem;
    className?: string;
}

export function SingleLineComment({ update, className }: ISingleLineCommentProps) {
    const htmlString = update.commentEdit?.text;
    return useMemo(() => {
        if (typeof htmlString !== "string") {
            return <span className={className} />;
        }

        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlString);

        const lines: string[] = [];
        for (let i = 0; i < fragment.children.length; i++) {
            const child = fragment.children[i];
            if (child instanceof HTMLElement && child.innerText.length > 0) {
                for (const line of child.innerText.split("\n")) {
                    lines.push(line);
                }
            }
        }
        return <span className={className}>{lines.join(" ")}</span>;
    }, [htmlString]);
}
